interface ITextSelection {
    end: number;
    start: number;
}

/**
 * Return the selection only when it covers part of the text.
 * A selection spanning the whole text is treated as "no selection" so that a style change applies
 * at object level (and on the field) instead of being stored per character: fabric drops character
 * level styles as soon as the text is deleted, which would send the text back to the default look.
 */
function getPartialTextSelection(textLength: number, selection?: ITextSelection): ITextSelection | undefined {
    if (!selection) {
        return undefined;
    }
    const isWholeText = selection.start <= 0 && selection.end >= textLength;

    return isWholeText ? undefined : selection;
}

export { getPartialTextSelection };
export type { ITextSelection };
